import { Color, Flex, NumberFormat, Space, Spacing, Text } from '@billy/design-system'
import { PropsWithChildren, ReactElement } from 'react'

import { getCurrentLocale } from '../../../../../../../../../../utils'
import { SalesReportColorBox } from '../../../SalesReportColorBox'

interface SalesReportGraphTooltipBoxProps extends PropsWithChildren {
  color: Color
  value: number
}

export const SalesReportGraphTooltipBox = ({
  color,
  children,
  value,
}: SalesReportGraphTooltipBoxProps): ReactElement | null => {
  const locale = getCurrentLocale()

  return (
    <Flex flexDirection="column">
      <SalesReportColorBox alignItems="baseline" gap={Spacing.S8} color={color}>
        <Text color={Color.White} variant="bodySM" weight="bold" uppercase>
          {children}
        </Text>
      </SalesReportColorBox>
      <Flex>
        <Space horizontal />
        <Text color={Color.White} variant="h4" weight="regular">
          {NumberFormat.getFormattedNumber(value, locale, { minimumFractionDigits: 2 })}
        </Text>
      </Flex>
    </Flex>
  )
}
